<div class="new-playlist-title">
  <mat-icon matTooltip="Close" svgIcon="close" (click)='exit.emit()'></mat-icon>
  <span>
    {{ editItem?.Id ? 'Update' : 'Create' }}
    {{ isEditTypeEqualToPlaylist() ? 'Playlist' : 'Tag' }}
  </span>
</div>

<div>
  <div class="playlist-details playlist-items-selection-boundary" [class.opened-bottom-menu]="isBottomPanelVisible">
    <ng-container *ngIf="!isOwner">
      <span>Created by </span>
      <span>{{ editItem?.User?.FirstName }} {{ editItem?.User?.LastName }} </span>
      <span>at {{ dateCreated | date:'dd/MM/yyyy'}} </span>
    </ng-container>


    <form [formGroup]="form">
      <span>Name*</span>

      <input #playlistTitleElement formControlName="Title" type="text" placeholder="Title"
        [class.isAnimated]="!Title.value" (blur)="onBlur(true)" (focus)="onBlur(false)">

      <div *ngIf="Title?.touched && Title?.invalid" class="invalid-input">
        <div *ngIf="Title?.errors?.required">The field is required.</div>
        <div *ngIf="Title?.errors?.maxlength">Name cannot be longer than 50</div>
        <div *ngIf="Title?.errors?.nameExists">The name already exists.</div>
      </div>

      <ng-container *ngIf="isOwner">
        <div *ngIf="editItemType === libraryEditItemTypes.EditPlaylist">
          <span>Android</span>
          <mat-slide-toggle class="shared-playlist-toggle" [(ngModel)]="playlist.IsAndroid" [ngModelOptions]="{standalone: true}"
            (change)="onIsAndroidChanged($event.checked)"></mat-slide-toggle>
        </div>
        <div>
          <span>Shared</span>
          <mat-slide-toggle class="shared-playlist-toggle" formControlName="IsShared"></mat-slide-toggle>
        </div>
        <div *ngIf="IsShared.value">
          <span>Shared with</span>
          <div [matTooltip]="!isOwner ? 'Only owner can share' : ''" class="shared-play-list">

            <div *ngIf="!editItem?.IsSharedWithAllUsers">
              <input type="text" [disabled]="!isOwner" placeholder="Select user" [matAutocomplete]="auto"
                [(ngModel)]="autocompleteUserInput" name="autocompleteUserInput"
                (input)="autocompleteChanged($event.target.value)" [ngModelOptions]="{standalone: true}">

              <mat-autocomplete #auto="matAutocomplete" [displayWith]="matAutocompleteDisplayFn"
                class="autocomplete-custom">
                <mat-option *ngFor="let user of filteredUsers" (onSelectionChange)="onSelect(user)" [value]="user">
                  {{user.Email}}
                </mat-option>
              </mat-autocomplete>
            </div>

            <ng-container>
              <mat-checkbox [checked]="editItem?.IsSharedWithAllUsers" formControlName="IsSharedWithAllUsers"
                (change)="onShareWithAllChanged($event.checked)" class="light">Share with all</mat-checkbox>
            </ng-container>
          </div>
          <ul class="items-list" *ngIf="IsShared.value" cdkDropList (cdkDropListDropped)="drop($event)">
            <li *ngFor="let user of selectedUsersShared" class="shared-user-item">
              <span>{{ user.Email }}</span>
              <mat-icon *ngIf="isOwner" (click)="delete(user)" class="delete-button" svgIcon="close"
                matTooltip="Remove user"></mat-icon>
            </li>
          </ul>
        </div>
      </ng-container>

      <span>Description</span>
      <textarea formControlName="Description"></textarea>

      @if (editItemType === libraryEditItemTypes.EditPlaylist && playlist.IsAndroid) {
        <span>Transitions</span>

        <mat-select formControlName="Transition" [disableOptionCentering]="true" placeholder="Choose a transition effect"
          class="transition-select" panelClass="mat-transition-effect-select">
            @for (effect of transitionEffects | keyvalue: originalOrder; track $index) {
              <mat-option [value]="effect.value">{{ transitionEffectsLabels[effect.value] }}</mat-option>
            }
        </mat-select>

        <mat-checkbox class="light" formControlName="FitToVideoSize">Fit to video size</mat-checkbox>
      }

      <ng-container *ngIf="isEditTypeEqualToPlaylist()">
        <mat-checkbox class="light" *ngIf="editItem.PlaylistItems.length === 1 && !playlist.IsAndroid"
          matTooltipClass="custom-tooltip" formControlName="IsRepeated" [matTooltip]="tooltipMessage">
          Repeat
        </mat-checkbox>
      </ng-container>

      <ng-content select="[color-picker]"></ng-content>

    </form>

    <ng-content select="[content]"></ng-content>
  </div>

  <ng-content select="[footer]"></ng-content>
</div>
